<ngx-dynamic-hooks [content]="slice.content" [options]="{ sanitize: false }"></ngx-dynamic-hooks>
